import { CopySimple } from "@phosphor-icons/react";
import { copyToClipboard } from "@lib/utils";
import { trackEvent } from "@lib/utils";
import { COPY_ACCOUNT_ADDRESS } from "@constants/analytics";

interface CopyIconProps {
  address?: string;
}

const CopyIcon = ({ address }: CopyIconProps) => {
  const handleCopy = () => {
    if (address) {
      copyToClipboard(address);
      trackEvent(COPY_ACCOUNT_ADDRESS, {
        wallet_address: address,
      });
    }
  };

  return (
    <CopySimple
      size={24}
      onClick={handleCopy}
      style={{ cursor: "pointer" }}
      aria-label="Copy address"
    />
  );
};

export default CopyIcon;
